<template>
  <el-drawer :wrapperClosable="false" :title="title" :visible.sync="AddWorksFlag" size="60%" direction="rtl"
    :before-close="handleClose">

    <div class="demo-drawer__content">
      
      <el-form :model="addForm" :rules="rules" ref="ruleForm" v-loading="loading">
        <el-form-item label="平台" prop="platform_id" :label-width="formLabelWidth">
          <el-select v-model="addForm.platform_id" placeholder="请选择平台" filterable clearable style="width: 85%;">
            <el-option v-for="item in platformList" :key="item.id" :label="`${item.name}(${item.is_test==0?'正式':'测试'})`" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小说名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入小说名称" style="width: 85%;" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="简介" prop="description" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="addForm.description" placeholder="请输入简介" clearable
            :autosize="{ minRows: 2, maxRows: 10 }" style="width: 85%;" maxlength="500" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="作者名称" :label-width="formLabelWidth" prop="author">
          <el-tag 
            class="mr5"
            v-for="(tag, index) in addForm.author" 
            :key="tag + index" 
            closable 
            :disable-transitions="true" 
            @close="handleClosetag('author',index)" 
            @click="showInput('author',index)"
          >
            {{ tag }}
          </el-tag>

          <el-button v-if="!author.visible" class="button-new-tag" size="small" @click="showInput('author')">
            + 添加作者
          </el-button>
          <div>
            <el-input 
              v-if="author.visible" 
              v-model="author.value" 
              ref="authorInput" 
              style="width: 85%;"
              show-word-limit
              maxlength="20"
              placeholder="请输入作者名称"
              @keyup.enter.native="handleInputConfirm('author')" 
              @blur="handleInputConfirm('author')"
            >
            </el-input>
          </div>
        </el-form-item>

        <el-form-item label="上传封面" :label-width="formLabelWidth">
          <el-upload class="avatar-uploader" action :http-request="(file) => httpRequest(file)"
            accept=".jpg,.png,.jpeg,.bmp,.webp" :show-file-list="false" :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" style="border:1px solid #ccc;"></i>
          </el-upload>
          <div class="form_item_info">图片尺寸只能上传 600*800</div>
        </el-form-item>

        <el-form-item label="小说状态" :label-width="formLabelWidth" prop="status">
          <el-radio-group v-model="addForm.status">
            <el-radio :label="0">连载</el-radio>
            <el-radio :label="1">完结</el-radio>
          </el-radio-group>
        </el-form-item>
      
        <el-form-item label="章节总数" prop="chapter_total" :label-width="formLabelWidth">
          <el-input v-model="addForm.chapter_total" placeholder="请输入章节总数" style="width: 85%;" clearable
            oninput="value = value.replace(/[^\d]/g, '')"
          ></el-input>
            <!-- <div>连载中：填写当前已完稿准备上传的章节数量</div>
            <div>已完结：填写书籍章节总数</div> -->
        </el-form-item>

        <el-form-item label="付费方式" prop="sales_type" :label-width="formLabelWidth">
          <el-select v-model="addForm.sales_type" placeholder="请选择付费方式" clearable style="width: 85%;">
            <el-option label="全文付费" :value="1"></el-option>
            <el-option label="章节付费" :value="2"></el-option>
            <el-option label="免费" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="addForm.sales_type == 3 ? '免广告章节数' : '免费章节总数'" prop="free_chapter_total" :label-width="formLabelWidth"
          :rules="[{ required: addForm.sales_type != 3, message: '请输入章节数', trigger: ['blur', 'change'] },]"
        >
          <el-input v-model="addForm.free_chapter_total" style="width: 85%;" placeholder="请输入章节总数" clearable
            oninput="value = value.replace(/[^\d]/g, '')"
          ></el-input>
        </el-form-item>


        <!-- 以下-全文付费 -->
         <template v-if="addForm.sales_type == 1">
           <el-form-item label="全文价格" prop="total_price" :label-width="formLabelWidth">
             <el-input v-model="addForm.total_price" placeholder="请输入全文价格" style="width: 85%;" clearable
              oninput="value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/(\.\d{2})\d+/g, '$1')"
             ></el-input>
           </el-form-item>
           <el-form-item label="全文价格（原价）" prop="total_origin_price" :label-width="formLabelWidth">
             <el-input v-model="addForm.total_origin_price" placeholder="请输入全文价格" style="width: 85%;" clearable
              oninput="value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/(\.\d{2})\d+/g, '$1')"
             ></el-input>
           </el-form-item>
         </template>
        <!-- 以上-全文付费 -->


        <!-- 以下-章节付费 -->
        <template v-if="addForm.sales_type == 2">
           <el-form-item label="单章价格" prop="chapter_price" :label-width="formLabelWidth">
             <el-input v-model="addForm.chapter_price" placeholder="请输入单章价格" style="width: 85%;" clearable
              oninput="value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/(\.\d{2})\d+/g, '$1')"
             ></el-input>
           </el-form-item>
           <el-form-item label="剩余全文付费折扣" prop="remaining_discount" :label-width="formLabelWidth">
             <el-input v-model="addForm.remaining_discount" placeholder="请输入剩余全文付费折扣" style="width: 85%;" clearable
              oninput="value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/(\.\d{2})\d+/g, '$1')"
             >
             <template slot="append">%</template>
            </el-input>
           </el-form-item>
           <el-form-item label="多章优惠包" prop="discount_pkg_list" :label-width="formLabelWidth">
            <el-button class="mb20" :disabled="addForm.discount_pkg_list.length >= 4" size="small" @click="handleAddItems">+ 添加优惠包</el-button>
            <div v-for="(item, index) in addForm.discount_pkg_list" :key="index">
              <div v-if="index != 0" class="item_line"></div>
              <el-form-item class="mb20" label="打包章节数量" :prop="'discount_pkg_list.'+index + '.chapterCount'" label-width="110px"
                :rules="[{ required: true, message: '请输入打包章节数量', trigger: 'blur' }]"
              >
                <div style="display: flex;">
                  <el-input v-model="item.chapterCount" placeholder="请输入打包章节数量" clearable style="width: 80%;"
                  oninput="value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/(\.\d{2})\d+/g, '$1')"
                  ></el-input>
                  <!-- 删除按钮 -->
                  <img @click="handleDelItems(index)" class="PUB_form_btn" src="@/assets/btn/sc.png" alt="">
                </div>
              </el-form-item>
              <el-form-item class="mb20" label="营销价格" :prop="'discount_pkg_list.'+index + '.price'" label-width="110px"
                :rules="[{ required: true, message: '请输入营销价格', trigger: 'blur'}]"
                oninput="value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/(\.\d{2})\d+/g, '$1')"
              >
                <el-input v-model="item.price" placeholder="请输入营销价格" clearable style="width: 80%;"></el-input>
              </el-form-item>
            </div>
          </el-form-item>
         </template>
        <!-- 以上-章节付费 -->

        <el-form-item label="频道" :label-width="formLabelWidth" prop="gender_type">
          <el-radio-group v-model="addForm.gender_type">
            <el-radio :label="1">男生</el-radio>
            <el-radio :label="2">女生</el-radio>
            <el-radio :label="3">不限</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 书籍分类 -->
        <el-form-item label="小说分类" prop="category" :label-width="formLabelWidth">
          <el-cascader 
            v-model="addForm.category" 
            style="width: 85%;"
            :options="categoryList" 
            filterable 
            :props="{ value: 'code', label: 'name', children: 'children', emitPath: true }"
            placeholder="请选择小说分类" 
            @change="handleChange" 
          ></el-cascader>
        </el-form-item>

        <!-- 书籍分类 -->
        <el-form-item label="自定义标签" prop="tags" :label-width="formLabelWidth">
          <el-tag 
            class="mr5"
            v-for="(tag, index) in addForm.tags" 
            :key="tag + index" 
            closable 
            :disable-transitions="true" 
            @close="handleClosetag('tags',index)" 
            @click="showInput('tags',index)"
          >
            {{ tag }}
          </el-tag>

          <el-button v-if="!tags.visible && addForm.tags.length < 3" class="button-new-tag" size="small" @click="showInput('tags')">
            + 添加标签
          </el-button>
          <div>
            <el-input 
              v-if="tags.visible" 
              v-model="tags.value" 
              ref="tagsInput" 
              style="width: 85%;"
              show-word-limit 
              maxlength="4"
              placeholder="标签长度范围：2-4字"
              @keyup.enter.native="handleInputConfirm('tags')" 
              @blur="handleInputConfirm('tags')"
            >
            </el-input>
          </div>
        </el-form-item>

      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="AddNone">取 消</el-button>
      <el-button type="primary" @click="addPush" :loading="loading">确 定</el-button>
    </div>
  </el-drawer>
</template>

<script>
import {KsNovalManagement} from "@/api/ksNovalManagement";
import { WorksListAPI } from '@/api/Works/WorksList';
import { processErrors } from "@/utils/errorHandler";
import SelectChecked from '@/components/Select/SelectChecked'
const api = KsNovalManagement();

export default {
  props: ['AddWorksFlag', "editID"],
  components: {
    SelectChecked
  },
  data() {
    const validateRemainingDiscount = function (rule, value, callback) {
      if(!value){
        callback('请输入剩余全文付费折扣');
      }else if (value == 0) {
        callback(new Error('折扣不能为 0%'));
      }else if (value > 100) {
        callback(new Error('折扣不能大于 100%'));
      } else {
        callback();
      }
    };
    const validatePkgList = function (rule, value, callback) {
      if(!value || value.length == 0){
        callback(new Error('请输入添加多章优惠包'));
      } else {
        callback();
      }
    };
    const validateLength20 = function (rule, value, callback) {
      if(!value){
        callback(new Error('请输名称'));
      } else if(value.length > 20){
        callback(new Error('名称不能超过20个字'));
      } else {
        callback();
      }
    };
    
    return {
      formLabelWidth: "140px",
      title: "新增",
      addForm: {
        platform_id: '',
        name: "",
        description: "",
        author: [],
        status: 1,
        gender_type: 3,
        chapter_total: '',
        chapter_price: '',
        sales_type: '',
        free_chapter_total: '',
        total_price: '',
        total_origin_price: '',
        remaining_discount: '',
        tags:[],
        discount_pkg_list:[],
        category: [],
        cover:'',
        category_id: '',
        subject_id: '',
      },
      rules: {
        platform_id: [
          { required: true, message: '请选择平台', trigger: ['blur','change'] },
        ],
        name: [
          { required: true, message: '', trigger: ['blur','change'], validator: validateLength20 },
        ],
        description: [
          { required: true, message: '请输入简介', trigger: 'blur' },
        ],
        // cover: [
        //   { required: true, message: '请选择图片', trigger: 'blur' },
        // ],
        author: [
          { required: true, message: '请添加作者名称', trigger: 'blur' },
        ],
        chapter_total: [
          { required: true, message: '请输入章节总数', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '请选择小说状态', trigger: 'blur' },
        ],
        sales_type: [
          { required: true, message: '请选择付费方式', trigger: 'blur' },
        ],
        total_price: [
          { required: true, message: '请输入全文价格', trigger: 'blur' },
        ],
        chapter_price: [
          { required: true, message: '请输入单章价格', trigger: 'blur' },
        ],
        remaining_discount: [
          { required: true, message: '', trigger: 'blur', validator: validateRemainingDiscount },
        ],
        gender_type: [
          { required: true, message: ' ', trigger: 'blur' },
        ],
        category: [
          { required: true, message: '请选择小说分类', trigger: 'blur' },
        ],
        discount_pkg_list: [
          { required: true, message: '', trigger: 'blur', validator: validatePkgList },
        ],
      },

      author:{
        visible: false,
        value: ''
      },
      tags:{
        visible: false,
        value: ''
      },
      imageUrl: "",
      categoryList: [],
      EditFlag: false,
      loading: false,
      platformList:[],
    };
  },
  created() {
    this.getCategoryList()
    this.getPlatformList()
  },
  mounted() {
    if (this.editID != "") {
      this.loading = true;
      api.ApiNovelInfo({id: this.editID}).then(res => {
        if (res.code == 0) {
          this.imageUrl = res.data.full_cover
          this.title = "编辑"
          this.updateObject(res.data, this.addForm)
          this.addForm.category = [res.data.category_id, res.data.subject_id]
          this.loading = false;
        } else {
          processErrors(res);
        }
      })
    } 
  },
  methods: {
    /**
     * 把a中的数据更新到b中，并不新增b的属性
     * a,b都得传对象
     */
    updateObject(a, b) {
      Object.keys(b).forEach(key => {
        if (a.hasOwnProperty(key)) {
          // 初始化值
          if(key == 'status'){
            b[key] = a[key]
          }else{
            b[key] = a[key] == 0 ? '' : a[key];
          }
        }
      });
    },
    handleAddItems() {
      if(this.addForm.discount_pkg_list.length < 4){
        this.addForm.discount_pkg_list.push({ count: '', price: '' });
      }
    },
    
    handleDelItems(index) {
      this.addForm.discount_pkg_list.splice(index, 1);
    },
    handleClosetag(key, index) {
      this.addForm[key].splice(index, 1);
    },
    showInput(key, index) {
      if(index || index == 0){
        // 编辑
        this[key].value = this.addForm[key].splice(index, 1)[0];
      }
      this[key].visible = true;
      this.$nextTick(() => {
        this.$refs[`${key}Input`].$refs.input.focus();
      });
    },
    handleInputConfirm(key) {
      let value = this[key].value;
      if(key == 'tags'){
        if(value.length > 1){
          this.addForm[key].push(value)
        }
      }else{
        value ? this.addForm[key].push(value) : '';
      }
      this[key].visible = false;
      this[key].value = '';
    },
        
    handleChange(value) {
      this.addForm.category_id = value[0]
      this.addForm.subject_id = value[1]
    },
    getCategoryList() {
      api.ApiCategorySelect().then(res => {
        if (res.code == 0) {
          this.categoryList = res.data
        } else {
          processErrors(res);
        }
      })
    },
    getPlatformList() {
      api.ApiPlatformList({pageNo: 1,pageSize: 999,}).then(res => {
        if (res.code == 0) {
          this.platformList = res.data.data
        } else {
          processErrors(res);
        }
      })
    },
        
    handleAvatarSuccess(res, file) {
      this.addForm.cover = URL.createObjectURL(file.raw);
    },

    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传封面大小不能超过 10MB!');
      }
      let isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width == 600 && img.height == 800;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message.error("上传图片尺寸只能是 600*800 !");
          return Promise.reject();
          return false;
        }
      );
      return isLt2M && isSize
    },
    httpRequest(file) {
      let api = WorksListAPI()
      let arrImg = new FormData()

      arrImg.append("file", file.file);

      api.fileUpload(arrImg).then((res) => {
        if (res.code == 0) {
          this.imageUrl = res.data.url_full;
          this.addForm.cover = res.data.url;
        } else {
          processErrors(res);
        }
      });
    },
    handleClose(done) {
      this.$emit('NoneDlog')
      this.$refs['ruleForm'].resetFields();
    },
    AddNone() {
      this.addForm = {
        platform_id: '',
        name: "",
        description: "",
        author: [],
        status: 1,
        gender_type: 3,
        chapter_total: '',
        chapter_price: '',
        sales_type: '',
        free_chapter_total: '',
        total_price: '',
        total_origin_price: '',
        remaining_discount: '',
        tags:[],
        discount_pkg_list:[],
        category: [],
        cover:'',
        category_id: '',
        subject_id: '',
      }
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true; 
          let query = {
            ...this.addForm
          }
          let msg = '添加成功'
          if(this.editID){
            query.id = this.editID
            msg = '编辑成功'
          }
          
          delete query.category

          // 重置其他付费方式相关字段
          switch(query.sales_type){
            case 1:
              query.chapter_price = '';
              query.remaining_discount = '';
              query.discount_pkg_list = [];
              break;
            case 2:
              query.total_price = '';
              query.total_origin_price = '';
              break;
            case 3:
              query.chapter_price = '';
              query.remaining_discount = '';
              query.discount_pkg_list = [];

              query.total_price = '';
              query.total_origin_price = '';
              break;
          }

          api.ApiNovelEdit(query).then(res => {
            if (res.code == 0) {
              this.$message({
                message: msg,
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          })
          this.loading = false;
        } else {

          return false;
        }
      });
    },
  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 0 !important;
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  //flex: 1; /* 让按钮平分容器宽度 */
  width: 320px;
  /* 设置按钮宽度为120px */
}

.demo-drawer__content {
  height: calc(100% - 80px);
  /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto;
  /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}

.item_line{
  width: 80%;
  border-top: 1px solid #f7f6f6;
  margin: 10px 0;
}

.form_item_info{
  color: var(--prev-color-primary);
  line-height: 24px;
  font-size: 12px;
}
</style>